import { ReactNode } from 'react'
import Sidebar from './Sidebar'
import AnalysisChatWidget from './AnalysisChatWidget'
import { useUIStore } from '../store/uiStore'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed)

  return (
    <div
      className="h-screen w-screen overflow-hidden bg-paper text-ink"
      style={{
        display: 'grid',
        gridTemplateColumns: sidebarCollapsed
          ? 'var(--sidebar-collapsed-width) 1fr'
          : 'var(--sidebar-width) 1fr',
        transition: 'grid-template-columns var(--transition-base)',
      }}
    >
      <Sidebar />
      <main className="min-w-0 overflow-y-auto">{children}</main>
      <AnalysisChatWidget />
    </div>
  )
}

